module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"gave_mileage_message":"<b>{mileage_amount}원 지급됨 |</b>","hidden_by_admin_message":"해당 리뷰는 등록 기준을 충족하지 않아 현재 노출되지 않습니다.","hidden_by_system_message":"해당 리뷰는 등록 기준을 충족하지 않아 현재 노출되지 않습니다.","hidden_by_before_confirmation_message":"게시글은 현재 검토 중이며, 확인 후 노출됩니다.","review_edit_or_delete_info":"리뷰 수정 또는 삭제를 원할 경우, 쇼핑몰 고객센터로 문의해 주세요."}}')
  delete Component.options._Ctor
}
